
import axios from 'axios'
import { url } from './url'

function getAdminUsers() {
    var urlString = `${url}/admin-user`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

function auth(email, password) {
    return axios.post(`${url}/auth/admin`, { email, password })
        .then(resp => {
            localStorage.setItem('adminUser', JSON.stringify(resp.data))
            axios.defaults.headers.common['token'] = resp.data.token
            return resp.data
        })
}
function createAdminUser(adminUser){
    var urlString = `${url}/admin-user`;
    return axios
        .post(urlString,adminUser)
        .then(res => res.data.id);
}
function updateAdminUser(adminUser){
    var urlString = `${url}/admin-user/${adminUser.id}`;
    return axios
        .put(urlString,adminUser)
        .then(res => res.data._id);
}

function deleteAdminUser(adminUserId){
    var urlString = `${url}/admin-user/${adminUserId}`;
    return axios
        .delete(urlString)
        .then(res => res.data);
}
export default {
    getAdminUsers,
    createAdminUser,
    updateAdminUser,
    deleteAdminUser,
    auth
};